<template>
  <div class="category-page">
    <!-- 分类标签 -->
    <div class="categories-container">
      <div class="categories">
        <div class="categories-type">源码分类：</div>
        <span
          v-for="(c, i) in categories"
          :key="i"
          :class="['category-item', { active: selectedCategory === c.id }]"
          @click="selectCategory(c.id)"
        >
          <img v-if="c.icon" :src="c.icon" class="icon" />
          {{ c.name }}
        </span>
      </div>
    </div>

    <!-- 卡片网格 -->
    <div class="product-grid">
      <ProductCard
        v-for="(p, i) in products"
        :key="i"
        :product="p"
        @click.native="handleCardClick(p)"
      />
    </div>
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        background
        layout="prev, pager, next, sizes, total"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[10, 15, 20]"
        :total="pageTotal"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue' // 引入复用组件
import { EventBus } from '@/eventBus.js'
import { BASE_URL } from '@/config/index.js'

export default {
  name: "CategoryPage",
  components: { ProductCard },
  data() {
    return {
      searchHandler: null, // 用来保存回调函数引用
      // keyword: '',
      selectedCategory: 0,
      currentPage: 1,
      pageSize: 15,
      pageTotal: 0,
      categories: [
        { id:0, name: "全部", icon: null },
        { id:1, name: "SpringBoot", icon: null },
        { id:2, name: "SSM", icon: null },
        { id:3, name: "小程序", icon: null },
        { id:4, name: "Python", icon: null },
      ],
      products: []
    }
  },
  props: {
    keyword: String,
    searchToken: [Number, String]
  },
  watch: {
    // 监听 token：每次 token 变都会发请求（无视 keyword 是否变化）
    searchToken: {
      immediate: true,
      handler() {
        this.loadProducts(this.keyword || '')
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时解绑
    if (this.searchHandler) {
      EventBus.$off('search-keyword', this.searchHandler)
    }
  },
  methods: {
    get(){
      // 保存回调函数引用，方便 later 解绑
      this.searchHandler = (keyword) => {
        console.log("收到搜索关键字:", keyword)
        this.loadProducts(keyword)
      }
      EventBus.$on('search-keyword', this.searchHandler)
    },
    selectCategory(id) {
      this.selectedCategory = id
      this.loadProducts(this.keyword);
    },
    handleCardClick(product) {
      // 通知父组件打开详情页
      this.$emit('open-detail', product)
    },
    loadProducts(searchKeyword) {
      this.$http.get('/system/products/getList?pageNum='+ this.currentPage +'&pageSize=' + this.pageSize
        + (this.selectedCategory !== 0? "&categoryId=" + this.selectedCategory: "")
        + ((searchKeyword !== '')?"&title="+searchKeyword:"")) // 调用你后端接口
        .then(res => {
          if(res.code === 200){
            res.rows.forEach(item => {
              item.coverImage = BASE_URL + item.coverImage
            })
            this.products = res.rows   // 按你后端返回结构调整
            this.pageTotal = res.total
          }else {
            console.error('加载产品状态非200', res)
            this.$message({
              message: res.msg || '加载失败',
              type: 'warning',
              duration: 3000 // 显示时长，单位毫秒
            })
          }
        })
        .catch(err => {
          console.error('加载产品失败', err)
        })
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadProducts(this.keyword)
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadProducts(this.keyword)
    }
  }
}
</script>

<style scoped>
/* 分类标签和网格样式可直接复用之前写好的 */
.category-page {
  padding: 20px 5%;
}
.categories-container {
  background-color: #fff;
  border-radius: 16px;
  padding: 20px 25px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;        /* 顶部对齐，多行自动增加高度 */
  justify-content: flex-start;
  flex-wrap: wrap;                /* 自动换行 */
  gap: 15px;                       /* 标签间距 */
  color: #444141;
  font-weight: 500;
  font-size: 16px;
}

.categories-container .categories-type {
  font-weight: bold; /* 加粗 */
}

.categories-container .categories {
  display: flex;
  align-items: center;                 /* 内部文字和按钮垂直居中 */
  flex-wrap: wrap;
  margin-bottom: -0.5px;
  gap: 12px;                            /* 标签间距 */
}

/* 分类标签 */
.categories {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}
.category-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 18px;                   /* 按钮大一些 */
  border-radius: 25px;                   /* 圆角更圆 */
  background: #f0f0f0;
  cursor: pointer;
  transition: 0.3s;
  height: 20px;           /* 固定高度 */
}
.category-item.active {
  background: linear-gradient(135deg, #6a11cb, #2575fc); /* 渐变背景 */
  color: white;
}
.category-item .icon {
  width: 18px;
  height: 18px;
}

/* 卡片网格 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}
.product-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.2s;
}
.product-card:hover {
  transform: translateY(-4px);
}
.product-card img {
  width: 100%;
  height: 140px;
  object-fit: cover;
}
.product-card h3 {
  font-size: 14px;
  padding: 10px;
  height: 40px;
  overflow: hidden;
}
.product-card .info {
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px;
  font-size: 13px;
  color: #666;
}
.product-card .price {
  color: #ff4d4f;
  font-weight: bold;
}
.pagination-container {
   display: flex;
   justify-content: center;
   margin-top: 30px;
   padding: 10px 0;
   background: #fff;
   border-radius: 12px;
   box-shadow: 0 4px 12px rgba(0,0,0,0.05);
 }
</style>



// WEBPACK FOOTER //
// src/components/CategoryPage.vue